import PropTypes from 'prop-types';
import React from 'react';

import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import DeleteModal from './DeleteModal/DeleteModal';
import styles from './styles/styles.module.scss';
import useToggle from '../../hooks/useToggle';
import PortalModal from '../shared/PortalModal';

function DeleteRecording({ trackId, userSlug, languageRegionCode }) {
  const [on, toggle] = useToggle(false);

  return (
    <>
      <div className={`btn ${styles.button}`} onClick={toggle} role="button">
        {StringConstantsMixin.strings.DELETE}
      </div>
      <PortalModal isOpen={on}>
        <DeleteModal languageRegionCode={languageRegionCode} trackId={trackId} toggle={toggle} userSlug={userSlug} />
      </PortalModal>
    </>
  );
}

DeleteRecording.propTypes = {
  languageRegionCode: PropTypes.string.isRequired,
  trackId: PropTypes.number.isRequired,
  userSlug: PropTypes.string.isRequired
};

export default DeleteRecording;
